const DEFAULT_COPY = {
  genericHeadline: 'Unlock the full report',
  headlineTemplate: (purpose) => `Unlock the full report for your ${purpose}`,
  genericReason: 'Get the complete premium evaluation for this floor plan.',
  includedLabel: 'What unlocks now',
  bullets: [
    'Personalized requirements review',
    'Full premium sections for this report',
    'Immediate purchase and return to the same analysis',
  ],
  purposeLabels: {
    personal: 'personal project',
    professional: 'professional review',
    client: 'client project',
    other: 'project',
  },
};

function normalizeExpectationsQuote(value) {
  const collapsed = value?.trim().replace(/\s+/g, ' ');

  if (!collapsed) {
    return null;
  }

  if (collapsed.length <= 120) {
    return collapsed;
  }

  return `${collapsed.slice(0, 117).trimEnd()}...`;
}

export function buildUnlockOffer(userIntent = {}, copyOverrides = {}) {
  const normalizedIntent = userIntent || {};
  const copy = {
    ...DEFAULT_COPY,
    ...copyOverrides,
    bullets: copyOverrides.bullets || DEFAULT_COPY.bullets,
    purposeLabels: {
      ...DEFAULT_COPY.purposeLabels,
      ...(copyOverrides.purposeLabels || {}),
    },
  };
  const expectationsQuote = normalizeExpectationsQuote(normalizedIntent.expectations);

  if (!expectationsQuote) {
    return {
      headline: copy.genericHeadline,
      primaryReason: copy.genericReason,
      includedLabel: copy.includedLabel,
      bullets: copy.bullets,
    };
  }

  const purpose = copy.purposeLabels[normalizedIntent.purpose] || copy.purposeLabels.other;

  return {
    headline: copy.headlineTemplate(purpose),
    primaryReason: copy.genericReason,
    expectationsQuote,
    includedLabel: copy.includedLabel,
    bullets: copy.bullets,
  };
}
